import actions from "../js/actions.js";
import $$ from "Dom7";
import URLS from "../js/Urls.js";
export default {
  methods: {
    openAlert: function () {
      var self = this; //self.$app.dialog.alert("Hello World");
    }
  },
  data: function () {
    return {
      loginobj: actions.LoginGetResult()
    };
  },
  on: {
    pageInit: async function () {
      var self = this;
      var loginobj = actions.LoginGetResult();
      $$("#clearforall").on("click", async function () {
        var temp = $$(".contentone input");
        var ShowNotificationNewReservation = temp.prop("checked");
        var temp1 = $$(".contenttwo input");
        var ShowNotificationUpdate = temp1.prop("checked");
        var temp2 = $$(".contentthree input");
        var ShowNotificationCancell = temp2.prop("checked");

        if (!ShowNotificationNewReservation === true) {
          temp.prop("checked", false);
        }

        if (ShowNotificationUpdate === true) {
          temp1.prop("checked", false);
        }

        if (ShowNotificationCancell === true) {
          temp2.prop("checked", false);
        }
      });
      var NotificationSettings = "";

      try {
        app.f7.preloader.show();
        var obj = {};
        obj.PropertyID = loginobj?.PropertyID;
        obj.UserID = loginobj?.UserID;
        await app.f7.request.promise.postJSON(URLS.GetNotificationSettings, {
          obj
        }).then(res => {
          NotificationSettings = res.data;

          if (NotificationSettings && !NotificationSettings.ShowNotificationUpdates) {
            $$('#ShowNotificationUpdates').prop('checked', false);
          }

          if (NotificationSettings && !NotificationSettings.ShowNotificationsCancellation) {
            $$('#ShowNotificationsCancellation').prop('checked', false);
          }

          if (NotificationSettings && !NotificationSettings.ShowNotificationsPMS) {
            $$('#ShowNotificationsPMS').prop('checked', false);
          }

          app.f7.preloader.hide();
        });
      } catch (e) {} // var Notifications=[];
      // Notifications.add(1);


      $$("#NotificationSaveBtn").on("click", async function () {
        var temp = $$(".contentone input");
        var ShowNotificationNewReservation = temp.prop("checked");
        var temp1 = $$(".contenttwo input");
        var ShowNotificationUpdate = temp1.prop("checked");
        var temp2 = $$(".contentthree input");
        var ShowNotificationCancell = temp2.prop("checked");
        var obj = {
          PropertyID: loginobj?.PropertyID,
          UserID: loginobj?.UserID,
          ShowNotificationsPMS: ShowNotificationNewReservation,
          ShowNotificationUpdates: ShowNotificationUpdate,
          ShowNotificationsCancellation: ShowNotificationCancell
        };
        await app.f7.request.promise.postJSON(URLS.SubmitNotificationFilters, {
          obj
        }).then(res => {
          app.f7.preloader.hide();
          var toastNotification = app.f7.toast.create({
            text: "Notification Settings Saved!",
            position: "center",
            closeTimeout: 1500
          }).open();
        });
      });
    }
  },
  id: 'a1aa78966a',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=settings-notifications><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i></a></div><div class="title sliding">Notifications</div><div class=right id=NotificationSaveBtn style="margin-right: 10px"><span class=material-icons>save</span></div></div></div><div class=page-content><div class="row clearall" style="margin-left: 60px" id=clearforall>Clear all</div><div class=list><ul><li><label class="item-checkbox item-content contentone"><input type=checkbox class=notificationCheckbox name=demo-checkbox value=1 checked=checked id=ShowNotificationsPMS> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title id=clearRes>New Reservations</div></div></label></li><li><label class="item-checkbox item-content contenttwo"><input type=checkbox class=notificationCheckbox name=demo-checkbox value=2 checked=checked id=ShowNotificationsCancellation> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title id=clearChan>Changes</div></div></label></li><li><label class="item-checkbox item-content contentthree"><input type=checkbox class=notificationCheckbox name=demo-checkbox value=3 checked=checked id=ShowNotificationsCancellation> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title id=clearCanc>Cancellations</div></div></label></li></ul></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .accountdiv {
    padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
  }

  .clearall {
    justify-content: flex-end;
    /* line-height: 2rem; */
    /* padding-left: 20px; */
    /* padding-right: 10px; */
    color: #3478f6;
    font-size: 18px;
    line-height: 3rem;
    width: 80%;
  }

  .accountdiv .profileicon {
    font-size: 35px !important;
    position: relative;
    top: 23px;
  }

  .list {
    margin: 10px;
  }

  .footer {
    padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
  }

  .icons {
    margin-right: 20px;
  }

  .footerlogoclass {
    margin-top: 10px;
    height: 2rem;
    width: auto;
  }

  .useremail {
    font-weight: 700;
  }

  .dialogcancelbtn {
    color: #eb4d3d;
  }

  .logoutbtn {
    color: #3478f6;
  }
`,
  styleScoped: false
};